<template>
  <layout-breadcrumb-cartao
    titulo="Questionário Home Care"
    cartaoCustom
    :breadcrumb="bread"
    :iconeSvg="RecursosPropriosSvg"
  >
    <div slot="cartao">
      <unicom-linha>
        <unicom-coluna sm="12">
          <CartaoInformacoesPrestador
            :loading="loadingPrestador"
            :objetoInformacoes="objetoPrestador"
            ref="prestador"
          />
        </unicom-coluna>
      </unicom-linha>
    </div>
    <div slot="cartao" v-if="!render">
      <div class="preenchimento">
        <unicom-spinner
          key="loading"
          style="min-height: 100.8px; display: flex; align-items: center"
          :tamanhoLoading="62"
          :tamanhoLinha="7"
          :velocidade="0.5"
          :marginTopTexto="30"
        />
      </div>
    </div>
    <div slot="cartao" v-if="render">
      <unicom-linha>
        <unicom-coluna sm="12">
          <CartaoInformacoesDadosCadastrais
            :objetoInformacoes="acreditacoes"
            @upload-arquivo="uploadArquivoHandler"
            @error="errorHandler"
            ref="dadosCadastrais"
          />
        </unicom-coluna>
      </unicom-linha>
    </div>
    <div slot="cartao" v-if="render">
      <unicom-linha>
        <unicom-coluna sm="12">
          <CartaoInformacoesInfraestrutura
            :objetoInformacoes="objetoInfraestrutura"
            @error="errorHandler"
            ref="objetoInfraestrutura"
          />
        </unicom-coluna>
      </unicom-linha>
    </div>
    <div slot="cartao" v-if="render">
      <unicom-linha>
        <unicom-coluna sm="12">
          <CartaoInformacoesAtendimento
            :objetoInformacoes="atendimentoIntercambio"
            @error="errorHandler"
            ref="atendimentoIntercambio"
          />
        </unicom-coluna>
      </unicom-linha>
    </div>
    <div slot="cartao" v-if="render">
      <unicom-linha>
        <unicom-coluna sm="12">
          <CartaoInformacoesDadosComplementaresDiretorTecnico
            :objetoInformacoes="direcaoLideranca"
            @error="errorHandler"
            ref="diretorTecnico"
          />
        </unicom-coluna>
      </unicom-linha>
    </div>
    <div slot="cartao" v-if="render">
      <unicom-linha>
        <unicom-coluna sm="12">
          <CartaoInformacoesServicos
            ref="servicos"
            :objetoInformacoes="servicos"
          />
        </unicom-coluna>
      </unicom-linha>
    </div>

    <div slot="cartao">
      <unicom-linha justificarItem="end" style="padding-top: 20px">
        <div
          v-if="status == 'RASCUNHO'"
          style="align-self: center;margin-right: 10px;"
        >
          Formulário salvo como Rascunho, para concluir o envio clique na opção
          FINALIZAR E ENVIAR
        </div>
        <unicom-coluna sm="12" md="auto">
          <unicom-botao
            class="fonte-secundaria texto"
            @click="mostrarModalHandler('voltar')"
            :altura="40"
            contornado
            :largura="172"
          >
            CANCELAR
          </unicom-botao>
        </unicom-coluna>
        <unicom-coluna sm="12" md="auto">
          <unicom-botao
            class="fonte-secundaria texto"
            @click="mostrarModalHandler('rascunho')"
            :altura="40"
            :largura="172"
            contornado
            :class="{ desativado: enviarDesativado }"
            :tooltipNome="enviarDesativado ? '' : 'Salvar rascunho'"
          >
            SALVAR RASCUNHO
          </unicom-botao>
        </unicom-coluna>
        <unicom-coluna sm="12" md="auto" alinhamento="start">
          <unicom-botao
            class="fonte-secundaria texto"
            @click="mostrarModalHandler('salvar')"
            :altura="40"
            :largura="172"
            :class="{ desativado: enviarDesativado }"
            :tooltipNome="enviarDesativado ? '' : 'Salvar'"
            :desabilitado="permitirSalvar"
          >
            FINALIZAR E ENVIAR
          </unicom-botao>
        </unicom-coluna>
        <!-- modais -->
        <modal-salvar-vue
          :value="mostrarModalSalvar"
          @input="modalSalvarHandler"
          @botao-confirmar="salvar()"
          @nao-salvar="fecharModalSalvar"
          :possuiAlgumErroConsiderado="possuiError"
        ></modal-salvar-vue>
        <modal-salvar-vue
          :value="mostrarModalRascunho"
          @input="modalRascunhoHandler"
          @botao-confirmar="salvar(true)"
          @nao-salvar="fecharModalRascunho"
          :possuiAlgumErroConsiderado="false"
          :tipoSalvar="'rascunho'"
        ></modal-salvar-vue>
        <modal-voltar-vue
          :value="mostrarModalVoltar"
          @input="modalVoltarHandler"
          @botao-confirmar="voltar()"
          :possuiAlgumErroConsiderado="possuiError"
        ></modal-voltar-vue>
        <modal-loading :value="salvando"></modal-loading>
      </unicom-linha>
    </div>
  </layout-breadcrumb-cartao>
</template>

<script>
// Import das abas
import CartaoInformacoesPrestador from "./componentes/CartaoInformacoesPrestador";
import CartaoInformacoesDadosCadastrais from "./componentes/CartaoInformacoesDadosCadastrais";
import CartaoInformacoesInfraestrutura from "./componentes/CartaoInformacoesInfraestrutura";
import CartaoInformacoesAtendimento from "./componentes/CartaoInformacoesAtendimento";
import CartaoInformacoesDadosComplementaresDiretorTecnico from "./componentes/CartaoInformacoesDadosComplementaresDiretorTecnico";
import CartaoInformacoesServicos from "./componentes/CartaoInformacoesServicos";

// Import Modais
import ModalSalvarVue from "../shared/ModalSalvar.vue";
import ModalVoltarVue from "../shared/ModalVoltar.vue";
import ModalLoading from "unimed-components/src/Components/Layout/ModalLoading/ModalLoading.vue";

//Import do mixin geral
import QuestionarioHomeCareMixin from "./QuestionarioHomeCare.mixin";

//Import dos mixins das abas
import PrestadorMixin from "@/views/RecursosPropriosQuestionarios/shared/mixins/questionarios/PrestadorMixin";
import DadosCadastraisMixin from "@/views/RecursosPropriosQuestionarios/shared/mixins/questionarios/DadosCadastraisMixin";
import InfraestruturaMixin from "@/views/RecursosPropriosQuestionarios/shared/mixins/questionarios/InfraestruturaMixin";
import AtendimentoMixin from "@/views/RecursosPropriosQuestionarios/shared/mixins/questionarios/AtendimentoMixin";
import DadosComplementaresDiretorTecnicoMixin from "@/views/RecursosPropriosQuestionarios/shared/mixins/questionarios/DadosComplementaresDiretorTecnicoMixin";
import ServicosMixin from "@/views/RecursosPropriosQuestionarios/shared/mixins/questionarios/ServicosMixin";

// import mixin validacao
import MixinValidacoes from "@/views/RecursosPropriosQuestionarios/shared/mixins/validation/MixinValidacoesQuestionario";

// Import Mixin Modais
import ModalMixin from "../shared/mixins/modal/ModalMixin";

export default {
  mixins: [
    QuestionarioHomeCareMixin,
    PrestadorMixin,
    DadosCadastraisMixin,
    InfraestruturaMixin,
    AtendimentoMixin,
    DadosComplementaresDiretorTecnicoMixin,
    ServicosMixin,
    MixinValidacoes,
    ModalMixin
  ],
  components: {
    CartaoInformacoesPrestador,
    CartaoInformacoesDadosCadastrais,
    CartaoInformacoesInfraestrutura,
    CartaoInformacoesAtendimento,
    CartaoInformacoesDadosComplementaresDiretorTecnico,
    CartaoInformacoesServicos,
    ModalSalvarVue,
    ModalVoltarVue,
    ModalLoading
  },
  data() {
    return {
      bread: [
        { titulo: "Início", url: "/home" },
        { titulo: "Recursos Próprios", url: "/recursos-proprios" },
        { titulo: "Questionário Home Care" }
      ],
      checkQuestionario: [],
      tipoAcao: "Salvar",
      objetoInformacoes: {},
      list: []
    };
  },
  computed: {
    possuiError() {
      return this.$store.getters.getTemErrors;
    },
    permitirSalvar() {
      return !this.$store.getters.getPermitirSalvamento;
    }
  }
};
</script>

<style lang="scss" scoped>
.corpo-pesquisa {
  min-height: 282px;
}
.preenchimento {
  margin: 2rem 0;
  background: #fff;
  border-radius: 15px;
  padding: 4rem;
}
</style>
